import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef,
  HostBinding,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { CheckComponent } from './check/check.component';

@Component({
  selector: 'ui-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule, CheckComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent implements OnInit, AfterViewInit {
  @Input() value = false;
  @Input() text?: string;
  @Input() id?: string;
  @Input() required = false;
  @Input() lines = 2;
  @Input() isGA = false;
  @Input() isExpandable = false;
  @Input() smallGap = false;
  @HostBinding('class.revert-star') @Input() requiredStarBeforeText = false;
  @HostBinding('class.space-around') @Input() spaceAround = false;
  @HostBinding('class.bold') @Input() boldLabel = false;
  @HostBinding('class.disabled') disabled = false;
  @HostBinding('class.expanded') expanded = false;
  @HostBinding('class.collapsed') isCollapsed = false;
  @ViewChild('textElement') textElement?: ElementRef<HTMLElement>;
  private isRegister = false;

  constructor(private cdr: ChangeDetectorRef) {}

  get checkboxValue() {
    return this.value;
  }

  set checkboxValue(val: any) {
    this.value = val;
    this.emitChange();
  }

  get translationPrefix(): string {
    return this.isGA ? 'GA.' : 'SH.';
  }

  onChange = (_: any) => {
    console.log();
  };

  ngOnInit() {
    this.emitChange();
  }

  ngAfterViewInit() {
    if (this.isExpandable) {
      setTimeout(() => {
        this.lines = this.countLines();
        this.isCollapsed = true;
        this.cdr.detectChanges();
      }, 100);
    }
  }

  emitChange() {
    if (!this.disabled && this.isRegister) {
      this.onChange(this.value);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(): void {
    this.isRegister = true;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

  toggle() {
    this.expanded = !this.expanded;
  }

  onExpandClick(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  countLines(): number {
    const el = this.textElement?.nativeElement;

    if (el) {
      const divHeight = el.offsetHeight;
      return divHeight / 22;
    }

    return 0;
  }
}
